import { useEffect, useRef, useState, useContext } from "react";
import { StorageServiceContext, StorageServiceInstance } from "../../services/storage";
import AdvertismentComponent from "../Advertisment";
import {
  ResumeSessionButtons, ResumeSessionColumn, ResumeSessionModalWindow, ResumeSessionSeat, ResumeSessionSeatColumn, ResumeSessionTeams,
} from "./styled";
import { BasicButton, BasicImgWrapper, BasicText, COLORS, FontFamilyTypeEnum } from "../styled";

interface ResumeSessionModalProps {
  onResume: () => void;
  onNewSeat: () => void;
  selectedSection: string;
  selectedRow: string;
  selectedSeat: string;
  selectedSuite: string;
}

const ResumeSessionModal = ({
  onResume,
  onNewSeat,
  selectedSection,
  selectedRow,
  selectedSeat,
  selectedSuite,
}: ResumeSessionModalProps): JSX.Element => {
  const {
    team1logoDataUrl, team2logoDataUrl, showSuites,
  } = useContext(StorageServiceContext);

  const isSpecialSection = selectedSection.startsWith("Special: ");
  const sectionName = isSpecialSection ? selectedSection.substring(9) : selectedSection;
  const hasSuite = showSuites && !!selectedSuite;

  return (
    <ResumeSessionModalWindow>
      <ResumeSessionColumn>
        <BasicText
          fontSize="24px"
          fontFamily={FontFamilyTypeEnum.SFPRO}
          fontWeight="800"
          color={COLORS.WHITE}
          padding="15px 0px 0px 0px"
        >
          Welcome Back!
        </BasicText>
        <BasicText
          fontSize="16px"
          fontFamily={FontFamilyTypeEnum.SFPRO}
          fontWeight="700"
          color={COLORS.WHITE}
          padding="16px 0px 0px 0px"
        >
          Would You Like To Skip Some
        </BasicText>
        <BasicText
          fontSize="16px"
          fontFamily={FontFamilyTypeEnum.SFPRO}
          fontWeight="700"
          color={COLORS.WHITE}
        >
          Steps & View Your Previously
        </BasicText>
        <BasicText
          fontSize="16px"
          fontFamily={FontFamilyTypeEnum.SFPRO}
          fontWeight="700"
          color={COLORS.WHITE}
        >
          Entered Seat Info
        </BasicText>
        <ResumeSessionTeams>
          <BasicImgWrapper
            src={team1logoDataUrl}
            cursor="auto"
            width="55px"
            crossOrigin="anonymous"
          />
          <BasicText
            fontSize="24px"
            fontFamily={FontFamilyTypeEnum.SFPRO}
            color={COLORS.WHITE}
            fontWeight="700"
            padding="18px 5px 0px 5px"
          >
            VS
          </BasicText>
          <BasicImgWrapper
            src={team2logoDataUrl}
            cursor="auto"
            width="55px"
            crossOrigin="anonymous"
          />
        </ResumeSessionTeams>
        <ResumeSessionSeat>
          <ResumeSessionSeatColumn width="11%" />
          <ResumeSessionSeatColumn width={isSpecialSection ? "78%" : "26%"}>
            <BasicText
              fontSize="16px"
              fontFamily={FontFamilyTypeEnum.SFPRO}
              fontWeight="700"
              color={COLORS.WHITE}
            >
              {hasSuite ? "Suite" : "Section"}
            </BasicText>
            <BasicText
              fontSize="22px"
              fontFamily={FontFamilyTypeEnum.SFPRO}
              fontWeight="700"
              color={COLORS.WHITE}
              padding="3px 0px 0px 0px"
            >
              {hasSuite ? selectedSuite : sectionName}
            </BasicText>
          </ResumeSessionSeatColumn>
          {!isSpecialSection && !hasSuite && (
          <ResumeSessionSeatColumn width="26%">
            <BasicText
              fontSize="16px"
              fontFamily={FontFamilyTypeEnum.SFPRO}
              fontWeight="700"
              color={COLORS.WHITE}
            >
              Row
            </BasicText>
            <BasicText
              fontSize="22px"
              fontFamily={FontFamilyTypeEnum.SFPRO}
              fontWeight="700"
              color={COLORS.WHITE}
              padding="3px 0px 0px 0px"
            >
              {selectedRow}
            </BasicText>
          </ResumeSessionSeatColumn>
          )}
          {!isSpecialSection && !hasSuite && (
          <ResumeSessionSeatColumn width="26%">
            <BasicText
              fontSize="16px"
              fontFamily={FontFamilyTypeEnum.SFPRO}
              fontWeight="700"
              color={COLORS.WHITE}
            >
              Seat
            </BasicText>
            <BasicText
              fontSize="22px"
              fontFamily={FontFamilyTypeEnum.SFPRO}
              fontWeight="700"
              color={COLORS.WHITE}
              padding="3px 0px 0px 0px"
            >
              {selectedSeat}
            </BasicText>
          </ResumeSessionSeatColumn>
          )}
          <ResumeSessionSeatColumn width="11%" />
        </ResumeSessionSeat>
        <ResumeSessionButtons>
          <BasicButton
            backgroundColor={COLORS.BLUE_MAIN}
            borderColor={COLORS.BLUE_MAIN}
            color={COLORS.WHITE}
            cursor="pointer"
            width="80%"
            padding="5px"
            onClick={onResume}
          >
            <BasicText
              fontSize="16px"
              fontFamily={FontFamilyTypeEnum.SFPRO}
              fontWeight="600"
              color={COLORS.WHITE}
            >
              Yes,
            </BasicText>
            <BasicText
              fontSize="16px"
              fontFamily={FontFamilyTypeEnum.SFPRO}
              fontWeight="600"
              color={COLORS.WHITE}
              padding="5px 0px 0px 0px"
            >
              Use Previous Seat Info
            </BasicText>
          </BasicButton>
          <BasicText
            fontSize="22px"
            fontFamily={FontFamilyTypeEnum.SFPRO}
            fontWeight="700"
            color={COLORS.WHITE}
          >
            &#9135;&#9135; OR &#9135;&#9135;
          </BasicText>

          <BasicText
            padding="16px 0px 0px 0px"
          />

          <BasicButton
            cursor="pointer"
            width="80%"
            padding="5px"
            onClick={onNewSeat}
          >
            <BasicText
              fontSize="16px"
              fontFamily={FontFamilyTypeEnum.SFPRO}
              fontWeight="600"
              color={COLORS.BLACK}
            >
              No,
            </BasicText>
            <BasicText
              fontSize="16px"
              fontFamily={FontFamilyTypeEnum.OSWALD}
              fontWeight="600"
              color={COLORS.BLACK}
              padding="5px 0px 0px 0px"
            >
              Enter New Seat Info
            </BasicText>
          </BasicButton>
        </ResumeSessionButtons>
      </ResumeSessionColumn>
    </ResumeSessionModalWindow>
  );
};

export default ResumeSessionModal;
